import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
/**
 * DocsPage — renders any file from /app/memory as HTML.
 * URL format: /docs/{slug}  →  loads /app/memory/{slug}.md
 * (E.g. /docs/apple-signin-setup → APPLE_SIGNIN_SETUP.md)
 */
export default function DocsPage() {
  const { slug } = useParams();
  const [md, setMd] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/docs/${slug}`,
          { withCredentials: true });
        setMd(data?.markdown || "");
      } catch (e) {
        setErr(e?.response?.data?.detail || "Doc not found");
      }
    })();
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] px-4 py-12">
      <div className="max-w-3xl mx-auto"
            data-testid={`docs-page-${slug}`}>
        <Link to="/account" className="text-sm text-[#C05746] hover:underline">
          ← Back to your account
        </Link>
        {err && (
          <div className="mt-6 p-6 bg-white border border-[#E8E5DF] rounded-2xl">
            <p className="text-sm text-[#C05746]">{err}</p>
          </div>
        )}
        {md != null && (
          <article className="mt-6 p-8 md:p-12 bg-white border border-[#E8E5DF] rounded-2xl prose prose-slate max-w-none
                                prose-headings:font-serif-display prose-headings:text-[#121614]
                                prose-h1:text-4xl prose-h2:text-2xl prose-h3:text-xl
                                prose-a:text-[#C05746] prose-strong:text-[#121614]
                                prose-code:text-[#8A6520] prose-code:bg-[#F7F3E8] prose-code:px-1 prose-code:rounded"
                    data-testid="docs-content">
            <ReactMarkdown>{md}</ReactMarkdown>
          </article>
        )}
      </div>
    </div>
  );
}
